/**----------------------------------------------------------------------------------------------------
 * Main index.js.
 *
 * European Union Public Licence V. 1.2
 * EUPL © the European Union 2007, 2016
 *
 * Modified: 2024, Eddy Scheper, OpenGeoGroep/ARIS BV
 */

import App from './js/App.js';
window.app = new App();
window.onload = window.app.onLoad;
